/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const ClothingGraphic = ({
  className,
  clothingGraphic = "/img/clothing-graphic-shirt.svg",
}) => {
  return (
    <img
      className={`clothing-graphic ${className}`}
      alt="Clothing graphic"
      src={clothingGraphic}
    />
  );
};

ClothingGraphic.propTypes = {
  clothingGraphic: PropTypes.string,
};
